import React from 'react';
import Home from './components/Home';
// import Demo from './components/Demo';
// import './App.css';
function App(){
    return(
        <React.Fragment>
            <Home/>
            {/* <Demo/> */}
        </React.Fragment>
    );
}

export default App;